import  request  from '../../Interceptor/request.js'

//户号判断
export function paySure(data) {
    return request({
        url: '/paymentInfo',
        method: 'post',
        data:data
    })
}